import { render, staticRenderFns } from "./UnderwaterCleaning.vue?vue&type=template&id=19f5459a&"
import script from "./UnderwaterCleaning.vue?vue&type=script&lang=js&"
export * from "./UnderwaterCleaning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports